export const ERROR_CODES = {
  // 共通エラー
  /** 共通: 操作権限なし */
  _811000_ROUTE_ACCESS_ERROR: '811000',
  /** 共通: 自治体設定なし */
  _811001_GOVERNMENT_SETTING_ERROR: '811001',
  /** 共通: API実行失敗 */
  _811010_API_EXECUTION_FAILED: '811010',

  // ログイン画面エラー
  /** ログイン画面: 自治体設定の取得失敗 */
  _811100_QUERY_GOVERNMENT_SETTING_ERROR: '811100',
  /** ログイン画面: 災害情報の取得失敗 */
  _811101_QUERY_DISASTER_ERROR: '811101',

  // 団体管理者ユーザ管理画面エラー
  /** 団体管理者ユーザ管理画面: ユーザの取得失敗 */
  _811201_FETCH_USER_ERROR: '811201',
  /** 団体管理者ユーザ管理画面: ユーザの登録失敗 */
  _811202_CREATE_USER_ERROR: '811202',
  /** 団体管理者ユーザ管理画面: ユーザの更新失敗 */
  _811203_UPDATE_USER_ERROR: '811203',
  /** 団体管理者ユーザ管理画面: ユーザの削除失敗 */
  _811204_DELETE_USER_ERROR: '811204',

  // 団体メンバユーザ管理画面エラー
  /** 団体メンバユーザ管理画面: ユーザの取得失敗 */
  _811301_FETCH_USER_ERROR: '811301',
  /** 団体メンバユーザ管理画面: ユーザの登録失敗 */
  _811302_CREATE_USER_ERROR: '811302',
  /** 団体メンバユーザ管理画面: ユーザの更新失敗 */
  _811303_UPDATE_USER_ERROR: '811303',
  /** 団体メンバユーザ管理画面: ユーザの削除失敗 */
  _811304_DELETE_USER_ERROR: '811304',

  // ファイルアップロードAPI
  /** ファイルアップロードAPI: HTTPSステータスコードが200番代以外 */
  _815001_S3_PUT_HTTP_STATUS_ERROR: '815001',
  /** ファイルアップロードAPI: レスポンスヘッダにETAGが含まれなかった */
  _815002_S3_PUT_NOT_FOUND_ETAG_ERROR: '815002',

  // プロジェクト一覧取得API
  /** プロジェクト一覧取得API: プロジェクト一覧の取得失敗 */
  _815101_GET_PROJECT_LIST_ERROR: '815101',

} as const
